import React from "react";
import { getUserUnlocks, unlocks } from "./getUserUnlocks";
import { getLockIcon } from "../battle/ArenaView/SubmissionMenu/icon-svg-getters/icon-folder.js";
import {setSeenUnlocksInLocalstorage} from '../b5-home/unlock-localstorage-operations'

class UnlocksList extends React.Component {

  componentDidMount() {
    //Mark these as SEEN!
    setSeenUnlocksInLocalstorage();
  }

  renderUnlockAvatar(model) {
    const style = {
      marginRight: "1.3em"
    };
    return (
      <div style={style} className="UnlockIconContainer">
        {
          model.isComplete && typeof model.iconFn === "function"
            ? model.iconFn("3.5em")
            : getLockIcon("3.5em")
        }
      </div>
    );
  }

  renderUnlock(model, key) {
    const nameText = model.isComplete ? model.name : "?????";

    const style = {
      container: {
        marginBottom: "3.2em",
        padding: this.props.viewportMode === "landscape" ? "1em" : "0",
        width: this.props.viewportMode === "landscape" ? "50%" : "100%"
      },

      titleRow: {
        display: "flex",
        alignItems: "center",
        marginBottom: "1.3em"
      },

      progressContainerStyle: {
        height: "0.6em",
        position: "relative",
        background: "#485471",
        // borderTop: "0.3em solid #3E475C",
        width: "98%", //quick hack to make the margins feel aligned (bc of outline)
        outline: "0.3em solid #200535",
        margin: "0.3em 1%"
      },
      progressFill: {
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        background: model.isComplete ? "#50E3C2" : "#DBE2F6",
        borderBottom: model.isComplete
          ? "0.3em solid #43CDAE"
          : "0.3em solid #CAD1E6",
        width: model.progressPercent
      },

      unlockText: {
        fontSize: "1.1em",
        textTransform: "uppercase",
        marginBottom: "0.7em"
      },
      requirementText: {
        color: model.isComplete ? "#1E8870" : "#585B72"
      }
    };

    const subText = model.isComplete
      ? model.completedText
      : model.requirementText;

    return (
      <div key={key} style={style.container}>
        <div style={style.titleRow}>
          <div>
            {this.renderUnlockAvatar(model)}
          </div>
          <div>
            <div style={style.unlockText}>
              {nameText}
            </div>
            <div style={style.requirementText}>
              {subText}
            </div>
          </div>
        </div>
        <div style={style.progressContainerStyle}>
          <div style={style.progressFill} />
        </div>
      </div>
    );
  }

  render() {
    const userUnlocks = getUserUnlocks();
    const containerStyle = {
      padding: "1em",
      display: this.props.viewportMode === "landscape" ? "flex" : "block",
      flexWrap: "wrap"
    };
    return (
      <div style={containerStyle}>
        {unlocks.map((unlock, i) => {
          const model = {
            name: unlock.name,
            requirementText: unlock.requirementText,
            completedText: unlock.completedText,
            acquiredNumber: unlock.acquiredNumber,
            requiredNumber: unlock.requiredNumber,
            iconFn: unlock.icon,

            ...userUnlocks[unlock.id]
          };
          return this.renderUnlock(model, i);
        })}
      </div>
    );
  }
}

export default UnlocksList;



// WEBPACK FOOTER //
// ./src/b5-unlocks/UnlocksList.js